import { sortBy } from 'shared-base';

export const data: any = [
  { id: 'W-01', prompt: 'Camouflaged WW2 toy tank' },
  { id: 'W-02', prompt: 'Thick big chipped blade sword for an orc' },
  { id: 'W-03', prompt: 'Spaceship with x-wings' },
  { id: 'W-04', prompt: 'Sci-fi hover plane made of reflective golden metal' },
  { id: 'M-01', prompt: 'Cobblestone well with an oriental roof' },
  { id: 'K-01', prompt: 'Margarita glass' },
  { id: 'B-01', prompt: 'Two story residential house, with a balcony, stucco walls, and a green roof',}, // prettier-ignore
  { id: 'B-02', prompt: 'Hospital complex with a few wings made of steel & glass' },
  { id: 'F-01', prompt: 'Cartoony looking nightstand in bright stylized wood' },
  { id: 'B-03', prompt: 'Medieval stone and wood house with a side tower' },
  { id: 'O-01', prompt: 'Blobby cartoon tree in fall colors' },
  { id: 'U-01', prompt: 'Yellow school bus' },
  { id: 'W-05', prompt: 'Elven spear with an emerald blade' },
  { id: 'U-02', prompt: 'Industrial red barrel with sliver rings' },
  { id: 'B-04', prompt: 'Stylized red wooden barn with a slanted roof' },
  { id: 'O-02', prompt: 'Palm tree' },
  { id: 'B-05', prompt: 'Convenient store with a large entrance in WallMart colors' },
  { id: 'F-02', prompt: 'Rusted four door locker for a gym' },
  { id: 'O-03', prompt: 'Old rusted tractor with an open cabin' },
  { id: 'U-03', prompt: 'Clutch hang bag made of brightly colored painted leather' },
].sort(sortBy('prompt'));
